import { add, endOfMonth, format } from 'date-fns';
import { useState } from 'react';

import mboApi from 'infrastructure/redux/adapters/mboAPI/mboApi';

interface UseStaffAvailableDatesSessionTypeParams {
  staffId: number;
  locationId: string;
}

const useStaffAvailableDatesSessionType = ({
  staffId,
  locationId,
}: UseStaffAvailableDatesSessionTypeParams) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(endOfMonth(add(new Date(), { months: 1 })));
  const [sessionTypeId, setSessionTypeId] = useState<number | undefined>(undefined);

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDate(endOfMonth(add(newDate, { months: 1 })));
    }
  };

  const {
    data: staffAvailableDatesSessionType,
    isLoading: arestaffAvailableDatesSessionTypeLoading,
    error: staffAvailableDatesSessionTypeError,
    isFetching: arestaffAvailableDatesSessionTypeFetching,
  } = mboApi.useGetAvailableLessonDatesQuery(
    {
      staffId,
      locationId,
      sessionTypeId,
      startDateTime: format(startDate, 'yyyy-MM-dd'),
      endDateTime: format(endDate, 'yyyy-MM-dd'),
    },
    {
      skip: !locationId || !sessionTypeId,
      refetchOnMountOrArgChange: true,
    },
  );

  return {
    staffAvailableDatesSessionType,
    arestaffAvailableDatesSessionTypeLoading,
    staffAvailableDatesSessionTypeError,
    arestaffAvailableDatesSessionTypeFetching,
    setstaffAvailableDatesSessionTypeStartDate: (value: Date) => setStartDate(value),
    setstaffAvailableDatesSessionTypeEndDate: (value: Date) => setEndDate(value),
    setAvailableDatesSessionTypeSessionTypeId: (value: number) => setSessionTypeId(value),
    availableDatesSessionTypeId: sessionTypeId,
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
  };
};

export default useStaffAvailableDatesSessionType;
